import React from "react";
import {Card} from "primereact/card";
import FullscreenLayout from "@/Themes/Default/Layouts/FullscreenLayout";
import {Button} from "primereact/button";
import {useAuth0} from "@auth0/auth0-react";

const OrgUnavailablePage = () => {
    const {
        logout
    } = useAuth0();

    return (
        <FullscreenLayout>
            <Card>
                <div className="public-form login-form flex flex-column gap-2">
                    <h3 className="m-0">Organisation Unavailable</h3>
                    <p>Sorry, but it seems that you tried to sign in using organization that can't be used in this system.</p>
                    <p>Please try to logout and sign back in with another organisation or contact our support in case of further issues.</p>
                    <Button
                        className="w-full block"
                        label="Logout"
                        onClick={() => logout()}
                    />
                </div>
            </Card>
        </FullscreenLayout>
    );
};

export default OrgUnavailablePage;